import { Flex, Table } from 'antd'
import React, { useState, useEffect } from 'react'
import { useSKspjdListQuery } from '../../../store/DianShangYeWuApi'
import RuleIncomeAdd from './RuleIncomeAdd'
import RuleIncomeEdit from './RuleIncomeEdit'
import RuleIncomeCopy from './RuleIncomeCopy'
function RuleIncomeList(props) {
    const [list, setList] = useState([])
    const {data, isSuccess} = useSKspjdListQuery({ddsr_spjd_qy_id:props.qy_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success' && data.Result){
            setList(data.Result)
        }else{
            setList([])
        }
    }, [data, isSuccess])
    const columns = [
        {
            title: '操作',
            dataIndex: 'ddsr_spjd_id',
            key: 'ddsr_spjd_id',
            render: (text, record) => <RuleIncomeCopy 
                                        ddsr_spjd_id={record.ddsr_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '收款单规则名称',
            dataIndex: 'ddsr_spjd_content',
            key: 'ddsr_spjd_content',
            render: (text, record) => <RuleIncomeEdit 
                                        ddsr_spjd_content={text} 
                                        ddsr_spjd_id={record.ddsr_spjd_id} 
                                        useList={props.useList} 
                                        deptList={props.deptList} 
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                    />,
        },
        {
            title: '收款单部门',
            dataIndex: 'ddsr_spjd_bm_name',
            key: 'ddsr_spjd_bm_name',
        },
        {
            title: '收款单往来类型',
            dataIndex: 'ddsr_spjd_zflx',
            key: 'ddsr_spjd_zflx',
        },
        {
            title: '收款单最小金额',
            dataIndex: 'ddsr_spjd_amount_min',
            key: 'ddsr_spjd_amount_min',
        },
        {
            title: '收款单最大金额',
            dataIndex: 'ddsr_spjd_amount_max',
            key: 'ddsr_spjd_amount_max',
        },
        {
            title: '新增记录',
            dataIndex: 'ddsr_spjd_uname',
            key: 'ddsr_spjd_uname',
            render: (text, record) => <span>{record.ddsr_spjd_uname} {record.ddsr_spjd_ctime}</span>,
        }
       
    ]
    return (
        <>
            <Flex
                justify='space-between'
                align='center'
               
            >       
               <RuleIncomeAdd 
                    qy_id={props.qy_id}
                    qy_name={props.qy_name}
                    yh_id={props.yh_id}
                    yh_name={props.yh_name}
                    useList={props.useList}
                    deptList={props.deptList}
               />
            </Flex>
            <Table
                columns={columns}
                dataSource={list}
                pagination={false}
                rowKey='ddsr_spjd_id'
                size='small'
                bordered
                className="custom-table"
                style={{marginTop:'10px'}}
            />
        </>
    )
}

export default RuleIncomeList